import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { ListSalaryComponentsResponse, PayrollListSalaryComponentsQueryVariables } from '../types';

export const buildListSalaryComponentsQuery = (withBonusComponents: boolean) => gql`
  query PayrollListSalaryComponents(
    $category: SalaryComponentCategory!
    $status: SalaryComponentStatus!
    $payType: SalaryComponentPayType
    $taxability: TaxabilitySettings
    $searchQuery: String
    ${withBonusComponents ? '$includeBonusComponents: Boolean' : ''}
  ) {
    payrollListSalaryComponents(
      category: $category
      status: $status
      payType: $payType
      taxability: $taxability
      searchQuery: $searchQuery
      ${withBonusComponents ? 'includeBonusComponents: $includeBonusComponents' : ''}
    ) {
      data {
        source
        salaryComponents {
          id
          name
          description
          category
          settings {
            behaviour {
              pfBehaviour {
                includeInPfWages
              }
              ptBehaviour {
                includeInPtWages
              }
              esiBehaviour {
                includeInEsiWages
              }
              lwfBehaviour {
                includeInLwfWages
              }
              otBehaviour {
                includeInOtWages
              }
              gratuityBehaviour {
                includeInGratuityWages
              }
              leaveEncashmentBehaviour {
                includeInLeaveEncashmentWages
              }
              baseCompensationBehaviour {
                includeInBaseCompensation
              }
              taxBehaviour {
                taxExemptionSection
                taxDeductionBehaviour
                taxExemptInNewRegime
                taxExemptInOldRegime
              }
              arrearBehaviour {
                considerInArrear
              }
              prorationBehaviour {
                supportProration
              }
              displayBehaviour {
                showZero
                visibleToEmployee
                displayName
              }
            }
            earningDetails {
              payType
            }
            deductionDetails {
              deductionType
              deductFrom
            }
            bonusDetails {
              clawbackDuration
              isTaxable
            }
            perquisiteDetails {
              isTaxable
            }
            nonPayableBenefitsDetails {
              isPartOfCTC
              visibilityToEmployee
            }
          }
          isPredefined
          isActive
          source
          componentSource
          defaultFormula
          componentType
        }
      }
      code
      success
      message
    }
  }
`;

export const listSalaryComponentsQuery = buildListSalaryComponentsQuery(false);

const listSalaryComponents = <T>(queryVariables: PayrollListSalaryComponentsQueryVariables) => {
  return graphQLApi<ListSalaryComponentsResponse<T>, PayrollListSalaryComponentsQueryVariables>({
    query: buildListSalaryComponentsQuery(queryVariables.includeBonusComponents === true),
    queryVariables,
  });
};

export default listSalaryComponents;
